/* ═══════════════════════════════════════════════════
   TrackLab v2 — Results Accordion & Ring Gauges
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  TL.results = {};

  TL.results.toggleStats = function (toggle) {
    var collapsible = toggle.nextElementSibling;
    if (!collapsible) return;
    var isOpen = toggle.classList.toggle('open');
    collapsible.classList.toggle('open', isOpen);
    // Init rings on first open so animations play
    if (isOpen) {
      TL.results.initRings();
    }
  };

  TL.results.toggleResult = function (card) {
    document.querySelectorAll('.v2-page .result-card').forEach(function (c) {
      if (c !== card) c.classList.remove('expanded');
    });
    var wasOpen = card.classList.contains('expanded');
    card.classList.toggle('expanded');

    // Show/hide dim overlay
    if (!wasOpen) {
      card.querySelectorAll('img[data-src]').forEach(function (img) {
        // Mirror views._activateSilks: bind the error fallback BEFORE
        // assigning src so a cached 404 still triggers the handler.
        if (TL.views && TL.views.applySilkFallback) {
          img.addEventListener('error', function onSilkError() {
            img.removeEventListener('error', onSilkError);
            TL.views.applySilkFallback(img);
          });
        }
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        if (TL.skeleton && TL.skeleton.silk) TL.skeleton.silk(img);   // team#129
      });
      TL.views.showOverlay();
      if (TL.analytics) TL.analytics.trackResultExpand(card);
      setTimeout(function () {
        card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 380);
    } else {
      TL.views.hideOverlay();
    }

    // Update URL hash for back-button restore
    if (!wasOpen && card.dataset.venue && card.dataset.time) {
      var slug = (card.dataset.venue || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      history.replaceState(null, '', '#' + slug + '-' + card.dataset.time);
    } else if (wasOpen) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  TL.results.initRings = function () {
    document.querySelectorAll('.v2-page .ring-fill[data-pct]').forEach(function (el) {
      var pct = parseInt(el.dataset.pct) || 0;
      var absPct = Math.abs(pct);
      var offset = Math.round(188 - (188 * absPct / 100));
      el.style.strokeDashoffset = offset;
      // Negative pct: fill counter-clockwise from the top
      // scaleY(-1) mirrors the fill direction; the SVG's rotate(-90deg)
      // already puts 0 at 12 o'clock, so flipping Y makes it go CCW from top
      if (pct < 0) {
        el.style.transformOrigin = '36px 36px';
        el.style.transform = 'scaleY(-1)';
      }
    });
  };

  /**
   * Select a horse in the finishing order and update the spotlight panel.
   */
  TL.results.selectResult = function (el, raceId) {
    var list = document.getElementById('v2FoList-' + raceId);
    var panel = document.getElementById('v2Spotlight-' + raceId);
    if (!list || !panel) return;

    // Highlight selected row
    list.querySelectorAll('.fo-row').forEach(function (r) { r.classList.remove('sel'); });
    el.classList.add('sel');

    // Read data from the clicked row
    var horse = el.dataset.horse || '';
    var jockey = el.dataset.jockey || '';
    var trainer = el.dataset.trainer || '';
    var score = Math.round(Number(el.dataset.score)) || 0;
    var odds = el.dataset.odds || '';
    var oddsMoney = el.dataset.oddsMoney || '';
    var cloth = el.dataset.cloth || '';
    var silkUrl = el.dataset.silkUrl || '';
    var silkColor = el.dataset.silkColor || '';
    var horseSlug = el.dataset.horseSlug || '';
    var jockeySlug = el.dataset.jockeySlug || '';
    var trainerSlug = el.dataset.trainerSlug || '';
    var position = el.dataset.position || '';
    var margin = el.dataset.margin || '';
    var won = el.dataset.won === 'true';
    var completed = el.dataset.completed === 'true';
    var valueSignal = el.dataset.valueSignal || '';
    var formTagsRaw = el.dataset.formTags || '';

    // Update spotlight panel
    var posEl = panel.querySelector('[data-slot="pos"]');
    if (posEl) {
      if (won) {
        posEl.innerHTML = '&#x1f3c6; 1st place';
      } else if (!completed) {
        posEl.textContent = 'Did not finish';
      } else {
        posEl.textContent = position;
      }
    }

    // Horse name
    var horseEl = panel.querySelector('[data-slot="horse"]');
    if (horseEl) {
      if (horseSlug) {
        horseEl.innerHTML = '<a href="/horse/' + horseSlug + '/" class="profile-link profile-link--horse m-hit" onclick="event.stopPropagation()">' + horse + '</a>';
      } else {
        horseEl.textContent = horse;
      }
    }

    // Silk badge
    var silkEl = panel.querySelector('[data-slot="silk"]');
    if (silkEl) {
      silkEl.innerHTML = '';
      if (silkUrl) {
        var img = document.createElement('img');
        img.src = silkUrl;
        img.alt = '';
        silkEl.appendChild(img);
        silkEl.style.background = '';
        if (TL.skeleton && TL.skeleton.silk) TL.skeleton.silk(img);   // team#129
      } else {
        silkEl.style.background = silkColor || 'var(--accent-fill)'; /* white cloth number needs deep blue */
        silkEl.textContent = cloth;
      }
    }

    // Jockey & trainer
    var metaEl = panel.querySelector('[data-slot="meta"]');
    if (metaEl) {
      var jStr = jockeySlug ? '<a href="/jockey/' + jockeySlug + '/" class="profile-link m-hit" onclick="event.stopPropagation()">' + jockey + '</a>' : jockey;
      var tStr = trainerSlug ? '<a href="/trainer/' + trainerSlug + '/" class="profile-link m-hit" onclick="event.stopPropagation()">' + trainer + '</a>' : trainer;
      metaEl.innerHTML = 'Jockey ' + jStr + ' \u00B7 Trainer ' + tStr;
    }

    // Build form tags grid
    var statsEl = panel.querySelector('[data-slot="stats"]');
    if (statsEl) {
      statsEl.innerHTML = '';
      if (formTagsRaw) {
        try {
          var tags = JSON.parse('[' + formTagsRaw + ']');
          tags.forEach(function (tag) {
            var div = document.createElement('div');
            div.className = 'str-item';
            div.innerHTML = '<div class="sl">' + tag.label + '</div><div class="sv' + (tag.quality !== 'good' ? ' neutral' : '') + '">' + tag.value + '</div>';
            statsEl.appendChild(div);
          });
        } catch (e) { /* skip malformed tags */ }
      }
    }

    // Build odds block
    var oddsEl = panel.querySelector('[data-slot="odds"]');
    if (oddsEl) {
      if (odds) {
        var signalClass = valueSignal === 'SUPER_VALUE' ? 'super-value' : (valueSignal === 'VALUE' ? 'value' : 'neutral');
        var signalLabel = valueSignal === 'SUPER_VALUE' ? ' \u00B7 Very underrated horse' : (valueSignal === 'VALUE' ? ' \u00B7 Underrated horse' : '');
        var returnText = oddsMoney ? '<span class="ob-bookmaker">' + oddsMoney + '</span>' : '';
        oddsEl.innerHTML =
          '<div class="odds-block ' + signalClass + '">' +
            '<div class="ob-signal">Final odds' + signalLabel + '</div>' +
            '<div class="ob-main"><span class="ob-frac">' + (odds === '1/1' ? 'Evens' : odds) + '</span>' + returnText + '</div>' +
          '</div>';
        oddsEl.style.display = '';
      } else {
        oddsEl.style.display = 'none';
      }
    }

    // Update card styling — amber border for winner, blue for others
    if (won) {
      panel.style.borderColor = '';
      panel.style.background = '';
    } else {
      // Accent tint from the blue palette token (--accent-rgb in tokens.css)
      panel.style.borderColor = 'rgba(var(--accent-rgb),0.25)';
      panel.style.background = 'rgba(var(--accent-rgb),0.04)';
    }
  };

  /**
   * Build a single stat element for the spotlight panel.
   */
  TL.results._buildStat = function (label, value, colorClass) {
    var stat = document.createElement('div');
    stat.className = 'wc-stat';

    var labelEl = document.createElement('div');
    labelEl.className = 'ws-label';
    labelEl.textContent = label;

    var valEl = document.createElement('div');
    valEl.className = 'ws-value ' + (colorClass || '');
    valEl.textContent = value;

    stat.appendChild(labelEl);
    stat.appendChild(valEl);
    return stat;
  };

  /**
   * Calculate ring gauge offset from percentage.
   * Exported for testing.
   */
  TL.results._ringOffset = function (pct) {
    return Math.round(188 - (188 * pct / 100));
  };
})();
